import styled from 'styled-components';

export const Wrapper = styled.footer`
	position: relative;
	color: var(--color-footer-text, #414145);
	height: var(--footer-height);
	display: flex;
	align-items: center;
`;

export const Logo = styled.div`
	flex: 1;
	font-family: 'Libre Baskerville', serif;
	color: var(--color-logo, #313139);
	font-size: 16px;
	text-align: center;
`;
